import React from "react";
import { AppBar, InputBase, NativeSelect } from "@material-ui/core";
import "./CampaignTableHeader.scss";
function CampaignTableHeader({
  searchItem,
  searchCampaign,
  rowsPerPage,
  handleChangeRowsPerPage
}) {
  return (
    <AppBar position="static" id="report-table-header">
      <div className="search">
        <InputBase
          className="input"
          placeholder="Search"
          value={searchItem}
          onChange={searchCampaign}
        />
        <i className="fa fa-search" aria-hidden="true" />
      </div>

      <div className="table-view">
        View
        <NativeSelect
          className="select"
          disableUnderline
          value={rowsPerPage}
          onChange={handleChangeRowsPerPage}
          name="viewTableRows">
          <option value="15" className="view-option">
            15
          </option>
          <option value="20" className="view-option">
            20
          </option>
          <option value="25" className="view-option">
            25
          </option>
        </NativeSelect>
      </div>
    </AppBar>
  );
}

export default CampaignTableHeader;
